export function PanelLeftIcon() {
  return (
    <svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.6499 0.650024V16.65M3.8499 16.65H15.4499C16.57 16.65 17.1301 16.65 17.5579 16.432C17.9342 16.2403 18.2402 15.9343 18.4319 15.558C18.6499 15.1302 18.6499 14.5701 18.6499 13.45V3.85002C18.6499 2.72992 18.6499 2.16987 18.4319 1.74204C18.2402 1.36572 17.9342 1.05976 17.5579 0.868011C17.1301 0.650024 16.57 0.650024 15.4499 0.650024H3.8499C2.7298 0.650024 2.16974 0.650024 1.74192 0.868011C1.3656 1.05976 1.05964 1.36572 0.867889 1.74204C0.649902 2.16987 0.649902 2.72992 0.649902 3.85002V13.45C0.649902 14.5701 0.649902 15.1302 0.867889 15.558C1.05964 15.9343 1.3656 16.2403 1.74192 16.432C2.16974 16.65 2.7298 16.65 3.8499 16.65Z'
        stroke='#CDD5DF'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
